
export function getURL(route: string, options: string) {
    const MBTAEndpoint = "https://api-v3.mbta.com";
    if(options.trim() == ""){
        return MBTAEndpoint + '/' + route
    }

    return MBTAEndpoint + '/' + route + "?" + options;
}

export function getConfig() {
    return {
        headers: {
            'x-api-key': import.meta.env.VITE_MBTA_API_KEY
        }
    }
}
